// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MobileOutlinedSvg from "@ant-design/icons-svg/es/asn/MobileOutlined";
import AntdIcon from '../components/AntdIcon';

var MobileOutlined = function MobileOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MobileOutlinedSvg
  }));
};

MobileOutlined.displayName = 'MobileOutlined';
export default React.forwardRef(MobileOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/MobileOutlined.js
// module id = 1503
// module chunks = 0